import {Injectable} from '@angular/core';
import {ICustomColumnService} from '../../../../interfaces/custom-columns';
import {IColumnSettings} from '../../../shared/shared/table/components/custom-columns-settings/column-settings';


@Injectable({
  providedIn: 'root'
})
export class CustomColumnService implements ICustomColumnService{
    private defaultColumns: Array<Omit<IColumnSettings,'uuid'>> = [
        {   
          cid: 'contract-001',
          status: 1,
          order: 0,
          type: "default",
          doc_id: null,
          field_name: "contract_control_name",
          label: "Contract"
        },
        {
          cid: 'category-002',
          status: 1,
          order: 2,
          type: "default",
          doc_id: null,
          field_name: "category_name",
          label: "Category"
        },
        {
          cid: 'organization-003',
          status: 1,
          order: 3,
          type: "default",
          doc_id: null,
          field_name: "name",
          label: "Organization"
        },
        {
          cid: 'startdate-004',
          status: 1,
          order: 4,
          type: "default",
          doc_id: null,
          field_name: "start_date",
          label: "Start date"
        },
        {
          cid: 'enddate-005',
          status: 1,
          order: 5,
          type: "default",
          doc_id: null,
          field_name: "end_date",
          label: "End date"
        },
        {
          cid: 'manager-006',
          status: 1,
          order: 6,
          type: "default",
          doc_id: null,
          field_name: "managers",
          label: "Managers"
        },
        {
          cid: 'contact-007',
          status: 1,
          order: 7,
          type: "default",
          doc_id: null,
          field_name: "contacts",
          label: "Contacts"
        },
        {
          cid: 'contractno-008',
          status: 1,
          order: 8,
          type: "default",
          doc_id: null,
          field_name: "contract_no",
          label: "Contract no"
        },
        {
          cid: 'createdat-009',
          status: 1,
          order: 9,
          type: "default",
          doc_id: null,
          field_name: "created_at",
          label: "Created at"
        },
        {
          cid: 'cost-010',
          status: 1,
          order: 10,
          type: "default",
          doc_id: null,
          field_name: "cost",
          label: "Monthly cost"
        },
        {
          cid: 'revenue-011',
          status: 1,
          order: 11,
          type: "default",
          doc_id: null,
          field_name: "revenue",
          label: "Revenue"
        }
      ];
  constructor() { }


  /**
   * Return the array of default custom columns
   * @returns Array<{}>
   */
  getCustomColumns(){
    return this.defaultColumns;
  }

}

